<h3 mat-dialog-title>Logos</h3>
<mat-dialog-content>


  <div class="logos-list">
  <input type="text" class="aip-widget-search aip-widget-search-input" placeholder="Search Logos" [(ngModel)]="searchLogos" />            
    <mat-selection-list class="logos-list-list stripe" [multiple]="false" [ngModel]="sLogosBind" (ngModelChange)="selectionChange($event)">
        <mat-list-option *ngFor="let v of getLogosList()" [value]="v.id" [id]="'logo-list-'+v.id">          
          <mat-pseudo-checkbox [state]="v.id==this.sLogoSelected?'checked':'unchecked'"></mat-pseudo-checkbox>
          <img class="image-fit" [src]="'/logos/'+v.file">
          <span class="list-name">{{v["name"]}}</span>
        </mat-list-option>
      </mat-selection-list>

      <div *ngIf="showEditable" class="add-buttons">
        <button [disabled]="!this.showAdd" mat-raised-button color="primary" class="aip-button" (click)="add()" cdkFocusInitial>Add</button>          
        <button [disabled]="!this.showDelete" mat-raised-button color="warn" class="aip-button-alt" (click)="delete()">Delete</button>
      </div>

    </div>

      <div class="logos-fields">

        <div class="logo">
        <img *ngIf="this.sFile!=''" class="image-fit-big" [src]="'/logos/'+this.sFile">
        </div>

        <div>
        <label>Name</label>
          <input [readonly]="!this.showEditable || this.sLogoSelected==''" #nameField matInput type="text" class="aip-input" [(ngModel)]="this.sName" (keyup)="this.nameChange($event)"/>   
          <mat-error *ngIf="this.fieldMessage['name'] != ''">
            {{this.fieldMessage["name"]}}
          </mat-error>
        </div>

        <div>
        <label>File</label>
        <div>
        <input [readonly]="true" matInput type="text" class="aip-input aip-input-file readonly" [(ngModel)]="this.sFile"/>   
        <input type="file" #file placeholder="Choose file" (change)="uploadFile(file.files)" style="display:none;"> 
        <button matTooltip="Upload" class="aip-file-button" mat-raised-button (click)="file.click()" [disabled]="!this.showEditable || this.sLogoSelected==''">
          <fa-icon class="" icon="file-image"></fa-icon>
        </button>
        </div>
        </div>

        <div>
        <label>Company</label>
        <input [readonly]="!this.showEditable || this.sLogoSelected==''" matInput type="text" class="aip-input" [(ngModel)]="this.sCompany" (keyup)="this.companyChange($event)"/>   
        </div>

        <div>
          <label>Source</label>
          <input [readonly]="!this.showEditable || this.sLogoSelected==''" matInput type="text" class="aip-input" [(ngModel)]="this.sSource" (keyup)="this.sourceChange($event)"/>   
        </div>

      
      <div *ngIf="showEditable" class="form-buttons">
       
        <button [disabled]="!this.showSave" mat-raised-button color="primary" class="aip-button" (click)="save()" cdkFocusInitial>Save</button>          
        <button [disabled]="!this.showCancel" mat-raised-button class="aip-button-alt" (click)="cancel()">Cancel</button>              
      </div>

      </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
          <!-- there are for when we allow users to add logos from the account or entity panel - so you could and select only using from admin
          just now so just have a close button   
    <button mat-raised-button color="primary" class="aip-button" (click)="select()" [mat-dialog-close]="data" cdkFocusInitial>Select</button>        
    <button mat-raised-button class="aip-button-alt" (click)="close()">Cancel</button>
          -->
          <button mat-raised-button class="aip-button-alt" (click)="close()">Close</button>
</mat-dialog-actions>